import { makeAutoObservable, runInAction } from 'mobx'
import { decorate, injectable, inject } from 'inversify'

import { Api } from '@evertel/api'
import { APIDataAgreementDocument } from '@evertel/types'

export interface PendingAgreementItem {
    departmentAgreementId: number
    agreementAssignmentId: number
    roomId: number
    acceptOncePerRoom: boolean
    document: APIDataAgreementDocument
}

class AgreementGateController {
    pendingAgreements: PendingAgreementItem[] = []
    currentIndex = 0
    roomId: number | null = null

    constructor(
        private api: Api
    ) {
        makeAutoObservable(this)
    }

    init = async (roomId: number) => {
        this.roomId = roomId
        this.currentIndex = 0
        this.pendingAgreements = []

        await this.fetchPendingAgreements()
    }

    fetchPendingAgreements = async () => {
        if (!this.roomId) return

        const results = await this.api.Routes.Room.getResolveAgreements(this.roomId)

        runInAction(() => {
            this.pendingAgreements = (results ?? []) as PendingAgreementItem[]
        })
    }

    accept = async () => {
        const item = this.currentAgreement
        if (!item) return

        await this.api.Routes.DepartmentAgreement.postAccept(item.departmentAgreementId, {
            agreementAssignmentId: item.agreementAssignmentId,
            agreementDocumentId: item.document.id,
            roomId: item.roomId
        })

        runInAction(() => {
            this.currentIndex += 1
        })
    }

    get currentAgreement(): PendingAgreementItem | null {
        return this.pendingAgreements[this.currentIndex] ?? null
    }

    get isComplete(): boolean {
        return this.pendingAgreements.length > 0 &&
            this.currentIndex >= this.pendingAgreements.length
    }

    get hasPendingAgreements(): boolean {
        return this.pendingAgreements.length > 0 && !this.isComplete
    }

    get totalCount(): number {
        return this.pendingAgreements.length
    }

    get currentStep(): number {
        return this.currentIndex + 1
    }
}

decorate(injectable(), AgreementGateController)
decorate(inject(Api), AgreementGateController, 0)

export { AgreementGateController }
